import * as yup from 'yup';

export interface AffiliateNewFormValues {
  referrer_name: string;
  referrer_email: string;
  referrer_phone: string;
  referrer_company: string;
  /** Linked customer — null means no linkage. */
  customer_id: number | null;
  referral_code: string;
  tier: string;
  /**
   * Fallback commission percent. Optional — blank means the API picks its
   * own default. yup casts empty string to NaN; we normalise NaN → undefined
   * so the field is genuinely absent from the payload when left blank.
   */
  commission_percent?: number;
  payout_threshold: number;
}

export const affiliateNewSchema = yup.object({
  referrer_name: yup.string().required('Referrer name is required'),
  referrer_email: yup
    .string()
    .email('Invalid email format')
    .required('Email is required'),
  referrer_phone: yup.string().default(''),
  referrer_company: yup.string().default(''),
  customer_id: yup.number().nullable().default(null),
  referral_code: yup.string().default(''),
  tier: yup.string().default('standard'),
  commission_percent: yup
    .number()
    .transform((value) => (Number.isNaN(value) ? undefined : value))
    .min(0, 'Min 0%')
    .max(100, 'Max 100%')
    .optional(),
  payout_threshold: yup.number().min(0).default(500000),
});

export const TIER_OPTIONS: { value: string; label: string }[] = [
  { value: 'standard', label: 'Standard' },
  { value: 'silver', label: 'Silver' },
  { value: 'gold', label: 'Gold' },
  { value: 'platinum', label: 'Platinum' },
];
